import React, { useState } from "react";

function YardWasteRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "What’s the best way to dispose of yard waste?",
      content: `
  The best options for disposal include professional yard waste removal services, composting in a compost pile, or using a local waste management company that offers yard waste containers.
      `,
    },
    {
      title: "Can I place yard waste in plastic bags?",
      content: `
      Many city services and local regulations prohibit plastic bags for yard debris. Instead, we recommend using paper bags or paper yard waste bags, which are biodegradable.
      `,
    },
    {
      title: "Do you remove biological waste or hazardous materials?",
      content: `
       We handle some hazardous waste depending on local guidelines. Contact us for detailed information.
      `,
    },
    {
      title: "What if I have a large amount of debris?",
      content: `
         For large tree removal or piles of yard waste, we offer Dumpster Rental and bulk yard debris pickup services.
        `,
    },
    {
      title: "Do you offer services in my zip code?",
      content: `
         We serve multiple locations, including New Jersey, San Antonio, and surrounding areas. Contact us with your zip code to confirm availability.
          `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default YardWasteRemovalFAQs;
